import { useEffect, useState } from "react";
import { useLocation, useNavigate, useRouteError } from "react-router-dom";
import { setAppError, setPage } from "../store/userSlice";
import { useDispatch } from "react-redux";
import ErrorSideBar from "./ErrorSideBar";
import ErrorMain from "./ErrorMain";

export default function Error({ component }) {
  const [navbarOpen, setNavbarOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const error = useRouteError();
  const location = useLocation();
  useEffect(() => {
    console.log(`Error at ${location?.pathname} => `, error);
    dispatch(
      setAppError({
        msg: `Something went wrong!`,
      })
    );
    navigate("/login");
  }, []);
  return (
    <div className="flex w-full relative">
      {/* <ErrorSideBar navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
      <div
        className={`w-full ${
          navbarOpen && " h-96 overflow-y-hidden sm:h-auto sm:overflow-auto"
        }`}
      >
        <ErrorMain navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
      </div> */}
    </div>
  );
}
